import { AxiosResponse, Canceler } from 'axios';
import { IPaginationResponseDto, ICollection, ICollectionRequestDtoWithVerifies, ISearchCollectionResponseDto } from '../types';
import settings from '../settings';
import api from './base';

export function getCollections(
  page = 1,
  limit = 20,
  isOnboarding?: boolean,
): [Promise<AxiosResponse<IPaginationResponseDto<ICollection>>>, Canceler] {
  const uri = `${settings.getApiURI()}/collection/v2/collections`;

  return api.getWithCancel(uri, {
    params: {
      page,
      limit,
      isOnboarding,
    },
  });
}

export function getCollection(trackingId: string): [Promise<AxiosResponse<ICollection>>, Canceler] {
  const uri = `${settings.getApiURI()}/collection/v2/collections/${trackingId}`;

  return api.getWithCancel(uri, {
    params: {
      isLive: true,
    },
  });
}

export function saveCollection(payload: Partial<ICollection>) {
  const uri = `${settings.getApiURI()}/collection/v2/collections`;

  return api.http.post(uri, payload);
}

export function editCollections(payload: ICollectionRequestDtoWithVerifies) {
  const uri = `${settings.getApiURI()}/collection/v2/collections`;

  return api.http.put(uri, payload);
}

export function duplicateCollection(trackingId: string) {
  const uri = `${settings.getApiURI()}/collection/v2/collections/duplicate`;

  return api.http.post(uri, {
    trackingId,
  });
}

export function deleteCollection(trackingId: string): Promise<AxiosResponse<ICollection>> {
  const uri = `${settings.getApiURI()}/collection/v2/collections/${trackingId}`;

  return api.http.delete(uri);
}

export function searchCollectionByTitle(
  keyword: string,
  isOnboarding?: boolean,
): [Promise<AxiosResponse<ISearchCollectionResponseDto<ICollection>>>, Canceler] {
  const uri = `${settings.getApiURI()}/search/v2/collections`;

  return api.getWithCancel(uri, {
    params: {
      keyword,
      isOnboarding,
    },
  });
}
